const serviceOldActionsPanel = {
  title: 'Acciones Abiertas de Servicios Anteriores',
  title2: 'ACCIONES ABIERTAS Y SIN PREGUNTA DE SERVICIOS ANTERIORES',
  accountable: 'Responsables: ',
  deadline: 'Fecha Limite: ',
  serviceDate: 'Fecha de Servicio: ',
  noAccountable: 'Sin responsable'
};

export default serviceOldActionsPanel;